// @tenorlab/nuxt-dashboard-pro
// file: app/async-widgets/widget-revenue-trends-async/meta.ts
// file: src/async-widgets/widget-revenue-trends-async/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { MonitorIcon as ComponentIcon } from '@tenorlab/vue-dashboard'

// Define the metadata object for the plugin
export const WidgetRevenueTrendsAsyncMeta: TWidgetMetaInfo = {
  name: 'Revenue Trends (async)',
  categories: ['Widget', 'Chart'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Displays revenue trends.',
  externalDependencies: [],
}
